import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Api from "../../services/Api";
import { showNotification as showNotificationAction, refreshView as refreshViewAction, translate } from "react-admin";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";

class DefaultButton extends Component {
  handleClick = (event) => {
    const { record, showNotification } = this.props;
    const updatedRecord = { ...record, default: event.target.checked };

    // Get default campaign and remove the default from it
    Api.getCampaigns({ default: true, coreShopId: record.coreShopId }).then((response) => {
      if (response["hydra:totalItems"] === 1) {
        const currentDefaultCampaign = { ...response["hydra:member"][0], default: false };
        Api.putCampaign(response["hydra:member"][0]["id"], currentDefaultCampaign).then((response) => {
          showNotification("resources.campaigns.undefaulted", "info", { messageArgs: { title: response.title } });
          this.updateCampaign(record.originId, updatedRecord);
        });
      } else if (response["hydra:totalItems"] > 1) {
        console.log("Please contact coupons api admin!");
        console.log(response);

      } else {
        this.updateCampaign(record.originId, updatedRecord);
      }
    });
  };

  updateCampaign(originId, updatedRecord) {
    const { showNotification, refreshView } = this.props;
    Api.putCampaign(originId, updatedRecord).then((response) => {
      showNotification("resources.campaigns.updated", "info", { messageArgs: { title: updatedRecord.title } });
      refreshView();
    });
  }

  render() {
    const { record } = this.props;
    return (<FormControlLabel
      control={
        <Checkbox
          checked={record.default}
          icon={<FavoriteBorder/>}
          checkedIcon={<Favorite/>}
          value={`${record.default}`}
          onChange={this.handleClick}
        />
      }
    />);
  }
}

DefaultButton.propTypes = {
  replace: PropTypes.func,
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction,
  refreshView: refreshViewAction
})(translate(DefaultButton));
